import {useDispatch, useSelector} from "react-redux";
import {
    clearTrackInfo,
    selectorAudioIsHidden,
    selectorAudioIsPlaying,
    selectorAudioPostId,
    selectorAudioProjectId,
    setAudioIsHidden,
    setAudioIsPlaying,
    setAudioPlaylistIds,
    setAudioPostId,
    setAudioProjectId
} from "../reducers/AudioSlice";

export const useGetPodcastLongreadProps = (projectId?: string, disabledSetPlaylist?: boolean) => {

    const postId = useSelector(selectorAudioPostId)
    const audioProjectId = useSelector(selectorAudioProjectId)
    const isPlaying = useSelector(selectorAudioIsPlaying)
    const isHidden = useSelector(selectorAudioIsHidden)
    const dispatch = useDispatch()

    const onPodcastPlay = (postIdParam: string, posts?: any) => {
        if (postId !== postIdParam) dispatch(clearTrackInfo())
        if (projectId !== audioProjectId) dispatch(setAudioPlaylistIds([]))
        dispatch(setAudioPlaylistIds(posts?.map((post: any) => post?.postId)) || [])
        dispatch(setAudioIsHidden((!postId || postId !== postIdParam) ? false : isHidden))
        dispatch(setAudioPostId(postIdParam))
        dispatch(setAudioProjectId(projectId))
        dispatch(setAudioIsPlaying((!postId || postId !== postIdParam) ? true : !isPlaying))
    }

    return {
        isPodcastPlaying: isPlaying,
        podcastPostId: postId,
        onPodcastPlay,
    }
}import {useDispatch, useSelector} from "react-redux";
import {
    clearTrackInfo,
    selectorAudioIsHidden,
    selectorAudioIsPlaying,
    selectorAudioPostId,
    selectorAudioProjectId,
    setAudioIsHidden,
    setAudioIsPlaying,
    setAudioPlaylistIds,
    setAudioPostId,
    setAudioProjectId
} from "../reducers/AudioSlice";

export const useGetPodcastLongreadProps = (projectId?: string, disabledSetPlaylist?: boolean) => {

    const postId = useSelector(selectorAudioPostId)
    const audioProjectId = useSelector(selectorAudioProjectId)
    const isPlaying = useSelector(selectorAudioIsPlaying)
    const isHidden = useSelector(selectorAudioIsHidden)
    const dispatch = useDispatch()

    const onPodcastPlay = (postIdParam: string, posts?: any) => {
        if (postId !== postIdParam) dispatch(clearTrackInfo())
        if (projectId !== audioProjectId) dispatch(setAudioPlaylistIds([]))
        dispatch(setAudioPlaylistIds(posts?.map((post: any) => post?.postId)) || [])
        dispatch(setAudioIsHidden((!postId || postId !== postIdParam) ? false : isHidden))
        dispatch(setAudioPostId(postIdParam))
        dispatch(setAudioProjectId(projectId))
        dispatch(setAudioIsPlaying((!postId || postId !== postIdParam) ? true : !isPlaying))
    }

    return {
        isPodcastPlaying: isPlaying,
        podcastPostId: postId,
        onPodcastPlay,
    }
}